// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { RedirectSourceEnum } from '../redirect-source-enum';

export const environment = {
  production: false,
  environment: 'staging',

  // the Application id for this specific app
  authAppId: 'pJP4w4_NEOlT5daTggnHMMqZHH8FikQmBEYHtQhW2CY',

  // the successful login return url
  authRedirectURI: 'https://portfoliostaging.reconcept.nl/login/success/',

  // the RedirectSource corresponding with backend
  authRedirectSource: RedirectSourceEnum.PORTFOLIO,

  // the requested grant scope
  authScope: 'user portfolio',

  // the authenticator title for this specific environment
  otpIssuer: 'Reconcept Staging',
  canChangeBE: true,

  bugsnagApiKey: 'd4948bc3c3690da8470e18c6ecc91cb4',

  applicationName: 'Portfolio',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
